import styled from 'styled-components';

interface IContainerProps {
    blank?: boolean;
}

export const Container = styled.button<IContainerProps>`
    display: flex;
    width: 33%;
    background-color: ${props => props.blank ? 'transparent' : '#FFFFFF'};
    border: none;
    text-align: left;
    cursor: ${props => props.blank ? 'default' : 'pointer'}!important;
    box-shadow: 1px 1px 1px #ddd;
    align-items: center;
    min-height: 145px;

    &:hover {
        background-color: ${props => props.blank ? 'transparent' : '#FAFAFA'};
    }

    @media screen and (max-width: 900px) {
        margin-bottom: 3px;
        width: 100%;
        display: ${props => props.blank ? 'none' : 'flex'};
        min-height: 60px;
        max-height: 60px;
    }
`

export const Icon = styled.img`
    padding: 5px;

    @media screen and (max-width: 900px) {
        width: 50px;
    }
`

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
`

export const Subtitle = styled.h4`
    font-size: 0.9em;
    font-weight: normal;
    color: #949499;
    margin-bottom: 3px;
`

export const Title = styled.h3`
    font-size: 1.2em;
    color: #7C7F81;
    font-weight: bold;

    @media screen and (max-width: 900px) {
        font-size: 1.1em;
    }
`